export class Pdvinfo {
  email: string;

  constructor({
    email = ""
  }: any) {
    this.email = email
  }
}

